import RouterPrompt from "./RouterPrompt";

export default RouterPrompt;
